import { QueryClient } from '@tanstack/react-query';

// TCX-790: keep React Query's default staleTime of 0 (every query is
// considered stale immediately → refetches on mount and on invalidation). A
// blanket non-zero default is unsafe here: freshness-sensitive queries that
// omit a per-query override would silently serve stale data. Concretely, after
// bookACall succeeds BookACallButton navigates to My Bookings without
// invalidating the bookings query, and MyBookings uses `bookingsQueryKey()`
// with no staleTime override — a non-zero default would hide the just-booked
// meeting until the window elapsed. Queries that CAN tolerate caching set
// their own explicit staleTime (e.g. useAppSettings, useLegalDocuments,
// useFranchable, LocationGrowth* use Infinity/minutes), so leaving the default
// at 0 is both correct and non-regressive. `staleTime: 0` is stated
// explicitly so the intent (never introduce a blanket non-zero default) is
// self-documenting.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
    },
  },
});

// Exported as a named singleton too so the login/logout code paths in
// api/auth.ts can clear the cache on identity change without pulling in a
// React hook. QueryClientProvider (components/app) uses this same instance.
export { queryClient };

export default queryClient;
